// extracted by mini-css-extract-plugin
module.exports = {"content":"article-grid_content__ssVR9","heading":"article-grid_heading__prA3L","grid":"article-grid_grid__No1IT"};